<template>
  <header>
    <a class="link__img" :href="serviceLink">
      <div v-if="service === 'costx'" class="logo" v-html="require('@/assets/img/costx-logo.svg')"></div>
      <div v-else class="logo" v-html="require('@/assets/img/bim-logo.svg')"></div>
    </a>
  </header>
</template>

<script>
export default {
  name: 'HeaderLogo',
  props: {
    service: String,
    serviceLink: String
  }
}
</script>

<style lang="scss" scoped>
header {
  text-align: center;
}

.logo {
  margin: 0 auto;
}

.link__img {
  cursor: pointer;
}
</style>
